import * as React from 'react';
import { Content, Grid, GridItem, PageSection, Split, SplitItem, Title } from '@patternfly/react-core';
import { PageActionsMenu } from '@app/components/PageActionsMenu';
import { DashboardNotificationsCard } from './Cards/NotificationsCard';
import { ClassesAtRiskCard } from './Cards/ClassesAtRiskCard';
import { PastWeekPerformanceCard } from './Cards/PastWeekPerformanceCard';
import { UpcomingDeliveriesCard } from './Cards/UpcomingDeliveriesCard';

const Dashboard: React.FunctionComponent = () => {
  // Each card fetches its own data on mount, so remounting them is the refresh
  const [refreshKey, setRefreshKey] = React.useState(0);

  return (
    <div>
      <PageSection hasBodyWrapper  isWidthLimited>
        <Split>
          <SplitItem><Title headingLevel="h1" size="lg">Dashboard</Title></SplitItem>
          <SplitItem isFilled />
          <SplitItem>
            <PageActionsMenu onRefresh={() => setRefreshKey(key => key + 1)} />
          </SplitItem>
        </Split>
      </PageSection>

      <PageSection hasBodyWrapper isWidthLimited>
        <Content>
          {/* hasGutter adds the standard PatternFly spacing between the cards */}
          <Grid hasGutter>
            
            {/* --- ROW 1 --- */}
            {/* Wider Card: Takes up 8/12 columns on desktop, full width on mobile */}
            <GridItem span={12} md={8}>
              <ClassesAtRiskCard key={refreshKey} />
            </GridItem>

            {/* Narrower Card: Takes up 4/12 columns on desktop */}
            <GridItem span={12} md={4}>
              <UpcomingDeliveriesCard key={refreshKey} />
            </GridItem>

            {/* --- ROW 2 --- */}
            {/* Wider Card */}
            <GridItem span={12} md={8}>
              <DashboardNotificationsCard key={refreshKey} />
            </GridItem>

            {/* Narrower Card */}
            <GridItem span={12} md={4}>
              <PastWeekPerformanceCard key={refreshKey} />
            </GridItem>

          </Grid>
        </Content>
      </PageSection>
    </div>
  );
};

export { Dashboard };
